import { Turbo } from '@hotwired/turbo-rails';
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    frame: String,
  };

  jump(e) {
    const url = e.currentTarget.value;
    if (this.hasFrameValue) {
      const frame = document.getElementById(this.frameValue);
      frame.src = url;
      Turbo.navigator.history.push(new URL(frame.src));
    } else {
      window.Turbo.visit(url);
    }
  }
}
